export interface BaseState {
    error: Error | string | null;
}

export interface Collection<S> extends BaseState {
    items: null | S[];
    isLoading: boolean;
}

export enum Region {
    AU = 'AU',
    NZ = 'NZ',
}

export enum Operation {
    VIEW_INVOICE = 'view_invoice',
    PAY_INVOICE = 'pay_invoice',
}

export interface UserInfo {
    operation: Operation[];
    region: Region;
}
